module.exports = __webpack_public_path__ + "static/media/5.de125303.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/rhand/5.png
// module id = 961
// module chunks = 0